module.exports = __webpack_public_path__ + "static/assets/01011831acb632804df035321ff68afe.svg";